// extracted by mini-css-extract-plugin
module.exports = {"word":"WordPracticeView_word__1b5AJ"};